// src/components/common/GeneralTooltip.js
import React, { useState, useEffect, useRef} from 'react';
import './GeneralTooltip.css';

const GeneralTooltip = ({ 
  children, 
  content, 
  position = 'top', 
  delay = 150,
  verticalOffset = 9,
  parentClassName = ''
}) => {
  const [visible, setVisible] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);
  const [horizontalOffset, setHorizontalOffset] = useState(0);
  const tooltipRef = useRef(null);
  const triggerRef = useRef(null);

  useEffect(() => {
    if (visible && triggerRef.current && tooltipRef.current) {
      const triggerRect = triggerRef.current.getBoundingClientRect();
      const tooltipRect = tooltipRef.current.getBoundingClientRect();
      const offset = (triggerRect.width - tooltipRect.width) / 2;
      setHorizontalOffset(offset);
    }
  }, [visible]);

  const showTooltip = () => {
    const id = setTimeout(() => {
      setVisible(true);
    }, delay);
    setTimeoutId(id);
  };

  const hideTooltip = () => {
    clearTimeout(timeoutId);
    setVisible(false);
  };

  return (
    <div className={`general-tooltip-wrapper ${parentClassName}`} ref={triggerRef}>
      <div 
        className="general-tooltip-trigger"
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
      >
        {children}
      </div>
      {visible && (
        <div className={`general-tooltip-box general-tooltip-${position}`}
             style={{
              marginBottom: `${verticalOffset}px`,
            left: `50%`,
            transform: `translateX(-50%)`}}>
          {content}
          <div className={`general-tooltip-arrow tooltip-arrow-${position}`} />
        </div>
      )}
    </div>
  );
};

export default GeneralTooltip;


